import "./transaction-route.scss";

import * as React from "react";

import {cst, cstAssign} from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Types}          from "@Common/types";

import {ReportsLayout}          from "../common/reports-layout";
import {AccountTransactionForm} from "./transaction-form";
import {TransactionFormState}   from "./transaction-form-state";
import {mapAsApiRequest}        from "./transaction-model";

export const AccountTransactionRoute = () => cst<{
    apis      : Types.Apis.Loaders.XpressoLoadApis,
    formState : Types.Xpresso.Account.Admin.Reporting.Transaction.FormStateNext,
}>(
    consumeContext("apis"),
    ({}, next) => ReportsLayout({activeTab: "transaction", next}),
    cstAssign("formState", ({}, next) => TransactionFormState({next})),
    ({apis, formState}) => (
        <div className="account-transaction-2k22">
            <AccountTransactionForm
                {...formState}
                onGenerateReport={async () => {
                    try {
                        apis.next.reporting.transactionDetailReport(mapAsApiRequest(formState.value))
                        window.alert("Your report has been requested and will be arriving to your inbox soon");
                    } catch (res) {
                        console.error(res);
                        window.alert("An error occurred. Please try again later");
                    }
                }}
            />
        </div>
    ),
);

